import React from 'react';
import {
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import { HeaderModal, ButtonConsensus, InputConsensus } from 'components';
import { colors } from 'utils/colorsSteps';

const ModalConfirmWithJustification = props => {
  const { open, onClose, header, message, justification, setJustification, onClick, disableConfirm } = props;

  const handleConfirm = () => {
    onClick();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="sm"
      >
        <HeaderModal onClose={onClose}>{header}</HeaderModal>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="h5">
              {message}
            </Typography>
          </DialogContentText>
          <DialogContent style={{ padding: 15 }}>
            <InputConsensus
              label="Justificativa"
              value={justification}
              onChange={e => setJustification(e.target.value)}
              multiline
              rows={4}
              variant="outlined"
              fullWidth
            />
          </DialogContent>
        </DialogContent>
        <DialogActions style={{ padding: 15 }}>
          <ButtonConsensus
            title="Cancelar"
            backgroundColor="#fff"
            hovercolor={colors.greySecundary}
            color={colors.greyShadow}
            onClick={onClose}
          />
          <ButtonConsensus
            title="Confirmar"
            backgroundColor={colors.primary}
            hovercolor={colors.primary}
            onClick={handleConfirm}
            disabled={disableConfirm}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ModalConfirmWithJustification;
